module.exports = __webpack_public_path__ + "static/media/22x28no1.8f60c2a7.jpg";